import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';

import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';

import Can from './../../Can';

import { makeStyles, withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import { green, red } from '@material-ui/core/colors';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import CardContent from '@material-ui/core/CardContent';
import { Alert, AlertTitle } from '@material-ui/lab';

import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';

import VehiclesServices from './../../../services/api/vehicles';

import { RouteSelect } from './../../Common/Selects/Route';
import { DriverSelect } from './../../Common/Selects/Driver';
import { CompanySelect } from './../../Common/Selects/Company';

import { getSessionCookie } from './../../../services/session';

const useStyles = makeStyles({
  table: {
    marginTop: '10px',
  },
  cardContent: {
    padding: '0px !important',
  },
  card: {
    marginTop: '1rem',
  },
  chipActive: {
    backgroundColor: green[100],
    color: green[700],
  },
  chipInactive: {
    backgroundColor: red[100],
    color: red[700],
  },
  select: {
    width: '100%',
    marginTop: '1em',
    marginBottom: '1em',
  },
});

const RedButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[500],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
}))(Button);

const GreenButton = withStyles((theme) => ({
  root: {
    color: 'white', //theme.palette.getContrastText(green[500]),
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
}))(Button);

export const VehiclesCreate = () => {
  const classes = useStyles();
  let history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const [requestError, setRequestError] = useState({
    error: false,
    errorDescription: null,
  });

  const [vehicle, setVehicle] = useState({
    status: true,
    driver: '',
    route: '',
  });

  const [companyId, setCompanyId] = useState(undefined);

  const [role, setRole] = useState('logged');

  useEffect(() => {
    let session = getSessionCookie();

    if (
      session !== undefined &&
      session.role !== undefined &&
      session.role !== null
    ) {
      setRole(session.role);
    }
  }, [vehicle.companyId]);

  const handleStatusChange = (event) => {
    setValue('status', event.target.value);
    setVehicle({ ...vehicle, status: event.target.value });
  };

  const handleRouteIdChange = (routeId) => {
    setValue('route', routeId);
    setVehicle({ ...vehicle, route: routeId });
  };

  const handleDriverIdChange = (driverId) => {
    setValue('driver', driverId);
    setVehicle({ ...vehicle, driver: driverId });
  };

  let vehicleSchema = yup.object().shape({
    number: yup.string().required(),
    headline: yup.string().required(),
    driver: yup.string(),
    route: yup.string(),
    imei: yup.string(),
    status: yup.boolean().required(),
  });

  const { handleSubmit, errors, control, setValue } = useForm({
    validationSchema: vehicleSchema,
  });

  const onSubmit = (data) => {
    setIsLoading(true);
    setRequestError({ error: false, errorDescription: null });

    setTimeout(function () {
      //Request
      VehiclesServices.create(data)
        .then((response) => {
          if (response === null || !response.IsValid) {
            setForm(vehicle);
            throw response.Message;
          }
          if (response.IsValid && response.Data !== undefined) {
            history.push(`/vehicles/detail/${response.Data.UnidadID}`);
          } else {
            throw response.Message;
          }
        })
        .catch((e) => {
          setRequestError({
            error: true,
            errorDescription: e.status ? e.Data.Message : e,
          });
          setIsLoading(false);
        });
    }, 1000);
  };

  const setForm = (data) => {
    setValue('number', data.Numero);
    setValue('headline', data.Titular);
    setValue('driver', data.ChoferUsuarioID);
    setValue('route', data.RutaID);
    setValue('status', data.EstaActivo ? true : false);
  };

  const handleCompanyChange = (value) => {
    setCompanyId(value);
  };

  return (
    <React.Fragment>
      <Card className={classes.card} style={{ background: '#f4f6f8' }}>
        <CardContent>
          <form
            className={classes.form}
            onSubmit={handleSubmit(onSubmit)}
            noValidate
          >
            {isLoading ? (
              <Skeleton count={5} height={50} />
            ) : (
              <React.Fragment>
                <Grid
                  container
                  spacing={2}
                  direction="row"
                  alignContent="center"
                  alignItems="flex-start"
                  justifyContent="space-between"
                >
                  <Grid item sm={6} xs={12}>
                    <Controller
                      as={<TextField />}
                      control={control}
                      rules={{ required: true }}
                      name="number"
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      required
                      id="number"
                      label="Numero"
                      autoComplete="number"
                      autoFocus
                      defaultValue=""
                      error={errors.number ? true : false}
                    />
                    <Can
                      role={role}
                      perform="superadmin"
                      yes={() => (
                        <CompanySelect
                          parentCallback={handleCompanyChange}
                          control={control}
                          error={errors.companyId ? true : false}
                        />
                      )}
                      no={() => ''}
                    />
                    <RouteSelect
                      parentCallback={handleRouteIdChange}
                      companyId={companyId}
                      routeId={vehicle.route}
                      control={control}
                      error={errors.route ? true : false}
                    />
                    <Can
                      role={role}
                      perform="superadmin"
                      yes={() => (
                        <Controller
                          as={<TextField />}
                          control={control}
                          name="imei"
                          defaultValue=""
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          id="imei"
                          label="IMEI"
                          autoComplete="imei"
                          error={errors.imei ? true : false}
                        />
                      )}
                      no={() => ''}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <Controller
                      as={<TextField />}
                      control={control}
                      rules={{ required: true }}
                      name="headline"
                      defaultValue=""
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      required
                      id="headline"
                      label="Titular"
                      autoComplete="headline"
                      error={errors.headline ? true : false}
                    />

                    <DriverSelect
                      parentCallback={handleDriverIdChange}
                      routeId={vehicle.driver}
                      control={control}
                      error={errors.driver ? true : false}
                    />

                    <Controller
                      as={
                        <FormControl
                          variant="outlined"
                          className={classes.select}
                        >
                          <InputLabel id="status-label">Estado</InputLabel>
                          <Select
                            labelId="status-label"
                            id="status"
                            autoWidth
                            value={vehicle.status}
                            onChange={handleStatusChange}
                            label="Estado"
                          >
                            <MenuItem value={true}>Activo</MenuItem>
                            <MenuItem value={false}>Inactivo</MenuItem>
                          </Select>
                        </FormControl>
                      }
                      className={classes.select}
                      name="status"
                      defaultValue={vehicle.status}
                      control={control}
                    />
                  </Grid>
                  <Grid item xs sm>
                    <Grid
                      container
                      spacing={1}
                      direction="row"
                      justifyContent="flex-end"
                    >
                      <Grid item>
                        <GreenButton
                          type="submit"
                          variant="contained"
                          color="primary"
                          size="large"
                          className={classes.button}
                          startIcon={<SaveIcon />}
                        >
                          Crear
                        </GreenButton>
                      </Grid>

                      <Grid item>
                        <RedButton
                          component={Link}
                          to="/vehicles"
                          variant="contained"
                          color="secondary"
                          size="large"
                          className={classes.button}
                          startIcon={<CancelIcon />}
                        >
                          Cancelar
                        </RedButton>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {requestError.error && (
                  <Grid
                    container
                    spacing={1}
                    direction="row"
                    justifyContent="flex-end"
                  >
                    <Grid item xs>
                      <Alert severity="error">
                        <AlertTitle>Algo salió mal</AlertTitle>
                        {requestError.errorDescription}
                      </Alert>
                    </Grid>
                  </Grid>
                )}
              </React.Fragment>
            )}
          </form>
        </CardContent>
      </Card>
    </React.Fragment>
  );
};
